import React from 'react';
import PropTypes from 'prop-types';
import './Icon.scss';

const Icon = props => (
    props.tagtype === 'span' ?
        <span onClick={props.onclick} className={props.icon + " x" + props.size}></span>
        :
        <i className={props.icon + " x" + props.size}></i>
);

Icon.propTypes = {
    icon: PropTypes.string,
    size: PropTypes.string,
    tagtype: PropTypes.string,
    onclick: PropTypes.func
};
export default Icon;